import './CoachInfo.css';
import Edward from '../../PageAssets/Photos/coach/Edward.jpg'
import Paulina from '../../PageAssets/Photos/coach/Paula.jpg'
import Marian from '../../PageAssets/Photos/coach/MarianKolasa.jpg'
import EdwardStar from '../../PageAssets/Photos/coach/EdwardStar.jpg'
import CoachOfTheYear from '../../PageAssets/Photos/coach/CoachOfTheYear.jpg'


const CoachInfo = () => { 


  return (
    <div id='CoachesMainDiv'>
      <div className='CoachDescDiv'>
        <h2 className='CoachHeader'>Edward Szymczak</h2>
        <img src={Edward} alt="Opis zdjęcia" className='CoachPhoto' />
 
 <section class="coach-bio">

  <h2>Architekt Sukcesów Polskiej Tyczki</h2>

  <p class="lead">
    Pasja, precyzja i dekady doświadczenia na najwyższym poziomie światowym.
  </p> 

  <p>
    Edward Szymczak to postać nierozerwalnie związana z historią polskiej lekkoatletyki.
    Jako wybitny trener klasy mistrzowskiej, od lat kształtuje nie tylko technikę skoku
    o tyczce, ale przede wszystkim charaktery mistrzów.
  </p>

  <p>
    Jego warsztat trenerski to unikalne połączenie naukowej analizy ruchu z intuicją,
    która pozwoliła mu wprowadzić rzeszę zawodników do ścisłej światowej elity.
  </p>

  <h3>🏆 Wybitni wychowankowie i ich osiągnięcia</h3>

  <p>
    Praca trenera Szymczaka zaowocowała dziesiątkami medali Mistrzostw Polski, Europy
    i Świata. Pod jego okiem skrzydła rozwijali zawodnicy, którzy na stałe zapisali się
    w historii sportu:
  </p>

  <ul>
    <li>
      <strong>Monika Pyrek – 4,81 m</strong> – jedna z najbardziej utytułowanych polskich
      lekkoatletek, medalistka Mistrzostw Świata i Europy, trzykrotna olimpijka.
    </li>
    <li>
      <strong>Anna Rogowska – 4,85 m</strong> – mistrzyni świata i medalistka olimpijska
      (współpraca na wczesnym etapie kariery oraz konsultacje).
    </li>
    <li><strong>Joanna Piwowarska – 4,52 m</strong></li>
    <li><strong>Róża Kasprzak – 4,50 m</strong></li>
    <li><strong>Anna Wielgus – 4,50 m</strong></li>
    <li><strong>Olga Frąckowiak – 4,30 m</strong></li>
  </ul>

  <p>
    Wśród zawodników znalazło się również wielu wybitnych tyczkarzy:
  </p>

  <ul>
    <li><strong>Mirosław Chmara – 5,90 m</strong></li>
    <li><strong>Marian Kolasa – 5,81 m</strong></li>
    <li><strong>Adam Kolasa – 5,75 m</strong></li>
    <li><strong>Władysław Kozakiewicz – 5,75 m</strong></li>
    <li><strong>Ryszard Kolasa – 5,71 m</strong></li>
    <li><strong>Krzysztof Kusiak – 5,70 m</strong></li>
  </ul>

  <p>
    Oraz wielu innych zawodników regularnie przekraczających barierę 5 metrów.
  </p>

  <h3>🎖️ Odznaczenia i uznanie</h3>

  <ul>
    <li>
      <strong>Krzyż Kawalerski Orderu Odrodzenia Polski</strong> – za wybitne zasługi
      dla rozwoju kultury fizycznej i osiągnięcia w pracy trenerskiej.
    </li>
    <li><strong>Złoty Krzyż Zasługi</strong></li>
    <li>
      Wielokrotne tytuły <strong>Trenera Roku</strong> w plebiscytach regionalnych
      i branżowych.
    </li>
    <li>
      W 2014 roku wyróżniony przez <strong>Polski Komitet Olimpijski</strong> tytułem
      Trenera Roku w sportach kobiecych w Polsce.
    </li>
    <img src={CoachOfTheYear} alt="Opis zdjęcia" className='CoachAwardPhoto' />
    <li>
      W 2023 roku odznaczony <strong>Gwiazdą w Alei Gwiazd Sportu</strong>
      we Władysławowie.
    </li>
    <img src={EdwardStar} alt="Opis zdjęcia" className='CoachAwardPhoto' />
  </ul>

  <h3>🔬 Filozofia treningu</h3>

  <p>
    Dla trenera Edwarda Szymczaka skok o tyczce to sztuka opanowania energii.
    W swojej pracy stawia na:
  </p>

  <ul>
    <li>
      <strong>Indywidualizację</strong> – dostosowanie techniki do warunków
      motorycznych zawodnika.
    </li>
    <li>
      <strong>Psychologię sportu</strong> – budowanie odporności mentalnej
      niezbędnej do startów na najwyższym poziomie.
    </li>
    <li>
      <strong>Innowacyjność</strong> – ciągłe poszukiwanie nowych metod
      doskonalenia technicznego.
    </li>
  </ul>

  <blockquote>
    „W skoku o tyczce nie ma drogi na skróty. Liczy się cierpliwość, powtarzalność
    i pełne zaufanie między trenerem a zawodnikiem.”
  </blockquote>

  <p class="cta">
    <strong>Chcesz nawiązać współpracę lub dowiedzieć się więcej?</strong>
    Zapraszamy do kontaktu oraz śledzenia aktualności z życia Polskiej Akademii Tyczki,
    której Edward Szymczak jest filarem.
  </p>

</section>

      </div>

      <div className='CoachDescDiv'>
        <h2 className='CoachHeader'>Paulina Dębska</h2>
        <img src={Paulina} alt="Opis zdjęcia" className='CoachPhoto' />
<section class="coach-bio">

  <h2>Nowa Energia w Polskiej Akademii Tyczki</h2>

  <p class="lead">
    Wicemistrzyni Polski, finalistka światowych mityngów i ambasadorka pasji do sportu.
  </p>

  <p>
    Paulina Dębska to postać, która skok o tyczce zna od podszewki. Przez lata obecna na
    najważniejszych stadionach w kraju i Europie, dziś swoją wiedzę, energię i doświadczenie
    przekuwa w sukcesy kolejnych pokoleń zawodników.
  </p>

  <p>
    Jej przejście z poziomu wyczynowej sportsmenki do roli trenera to naturalny etap rozwoju
    pasji, którą zaraża każdego, kto pojawi się na jej treningu.
  </p>

  <h3>🥇 Osiągnięcia zawodnicze</h3>

  <ul>
    <li>
      <strong>Rekord życiowy:</strong> 4,50 m – wynik stawiający ją w elicie polskich tyczkarek
      (osiągnięty m.in. podczas mityngu w Sopocie).
    </li>
    <li>
      <strong>Wicemistrzyni Polski Seniorów</strong> – wielokrotna medalistka krajowych
      czempionatów, zarówno w hali, jak i na stadionie.
    </li>
    <li>
      <strong>Reprezentantka Polski</strong> – uczestniczka prestiżowych mityngów
      międzynarodowych i zawodów z cyklu Pucharu Świata.
    </li>
    <li>
      Stawała na podium u boku takich ikon jak <strong>Monika Pyrek</strong>, udowadniając
      swoją klasę sportową przez wiele sezonów.
    </li>
  </ul>

  <h3>⚡ Nowe wyzwania: kariera trenerska</h3>

  <ul>
    <li>
      <strong>Empatia i podejście do zawodnika</strong> – doskonale rozumie emocje i wyzwania
      młodych tyczkarzy.
    </li>
    <li>
      <strong>Ambicja i głód wiedzy</strong> – nieustannie rozwija swój warsztat, korzystając
      z nowoczesnych metod treningowych.
    </li>
    <li>
      <strong>Analityczny umysł</strong> – potrafi rozłożyć skok na czynniki pierwsze i
      wychwycić kluczowe detale.
    </li>
  </ul>

  <h3>✨ Dlaczego Paulina?</h3>

  <p>
    Współpraca z Pauliną to szansa na trening pod okiem osoby, która nie tylko wie,
    jak skakać wysoko, ale potrafi tę wiedzę przekazać w sposób przystępny i inspirujący.
  </p>

  <blockquote>
    „Moim celem jest pokazanie, że skok o tyczce to nie tylko technika, to przede wszystkim
    odwaga i radość z przekraczania własnych granic.”
  </blockquote>

  <p class="cta">
    <strong>Chcesz trenować z Pauliną?</strong>
  </p>

  <p>
    Zapraszamy na konsultacje i treningi prowadzone przez jedną z najbardziej obiecujących
    trenerek młodego pokolenia.
  </p>

</section>

      </div>

      <div className='CoachDescDiv'>
        <h2 className='CoachHeader'>Marian Kolasa</h2>
        <img src={Marian} alt="Opis zdjęcia" className='CoachPhoto' />

<section class="coach-bio">

  <h2>Marian Kolasa – Solidność i Charakter Polskiej Szkoły Tyczki</h2>

  <p class="lead">
    Reprezentant kraju, olimpijczyk, zawodnik światowego poziomu i współtwórca złotej ery polskiej tyczki.
    Wielokrotny medalista mistrzostw Europy.
  </p>

  <p>
    Marian Kolasa to jeden z najbardziej cenionych polskich tyczkarzy swojej generacji.
    Przez lata reprezentował Polskę na arenie międzynarodowej, budując swoją sportową
    markę na solidności, konsekwencji i ogromnej kulturze technicznej.
  </p>

  <p>
    Jego kariera przypadła na okres wyjątkowo silnej polskiej szkoły skoku o tyczce,
    w której rywalizacja wewnętrzna i wysoki poziom sportowy pchały zawodników
    do ciągłego przekraczania własnych granic.
  </p>

  <h3>🏆 Kariera sportowa i osiągnięcia</h3>

  <ul>
    <li>
      <strong>Rekord życiowy: 5,81 m</strong> – wynik plasujący go w ścisłej czołówce
      europejskich tyczkarzy swojego okresu.
    </li>
    <li>
      <strong>Reprezentant Polski</strong> w zawodach międzynarodowych oraz prestiżowych
      mityngach lekkoatletycznych.
    </li>
    <li>
      <strong>Medalista Mistrzostw Polski</strong> – wielokrotnie stawał na podium
      krajowych czempionatów.
    </li>
    <li>
      Uczestnik zawodów, w których rywalizował z najlepszymi tyczkarzami świata,
      współtworząc renomę polskiej tyczki na arenie międzynarodowej.
    </li>
  </ul>

  <h3>💪 Styl i charakter zawodnika</h3>

  <p>
    Marian Kolasa był zawodnikiem wyróżniającym się spokojem, opanowaniem
    i niezwykłą powtarzalnością. Jego skoki cechowała techniczna precyzja
    oraz umiejętność utrzymania wysokiego poziomu sportowego przez wiele sezonów.
  </p>

  <p>
    To właśnie konsekwencja i odporność mentalna sprawiały, że był zawodnikiem,
    na którym można było polegać zarówno w startach krajowych, jak i międzynarodowych.
  </p>

  <h3>🧠 Doświadczenie i wpływ na kolejne pokolenia</h3>

  <p>
    Doświadczenie zdobyte na stadionach Europy i świata czyni z Mariana Kolasy
    cenne źródło wiedzy dla młodszych zawodników. Jego kariera jest przykładem,
    że długofalowa praca, cierpliwość i szacunek do rzemiosła sportowego
    są fundamentem prawdziwego sukcesu.
  </p>

  <blockquote>
    „W sporcie nie zawsze wygrywa ten, kto skacze najwyżej jednego dnia,
    ale ten, kto potrafi być gotowy przez wiele sezonów.”
  </blockquote>

  <p class="cta">
    <strong>Chcesz poznać historię polskiej tyczki od środka?</strong>
    Marian Kolasa to jeden z filarów pokolenia, które zbudowało renomę
    polskiego skoku o tyczce na arenie międzynarodowej.
  </p>

</section>

      </div>

    </div>
  );
};

export default CoachInfo;